<template>
  <div class="page-container">
    <div class="nav-wrap">
      <div class="logo-wrap">
        <router-link to="/"><img class="logo" src="../assets/repechage-logo-black.png" alt="repechage"></router-link>
      </div>
      <div class="nav-item-list">
        <div class="nav-item">
          <router-link to="/">首页</router-link>
        </div>
        <div class="nav-item">
          <router-link to="/about/lydia-sarfati">关于瑞波琴</router-link>
        </div>
        <div class="nav-item goods-link" @mouseover="showGoods=true" @mouseout="showGoods=false">关于产品</div>
        <div class="nav-item">
          <div class="dropdown-btn">科技研发</div>
          <div class="dropdown-content">
            <router-link to="/about/seaweed">关于海藻</router-link>
            <router-link to="/about/science">实验室科技</router-link>
          </div>
        </div>
        <div class="nav-item">
          <div class="dropdown-btn">新闻中心</div>
          <div class="dropdown-content">
            <router-link to="/news/blog">新闻资讯</router-link>
            <router-link to="/news/redbook">小红书</router-link>
          </div>
        </div>
        <div class="nav-item">
          <router-link to="/anti_fake">防伪查询</router-link>
        </div>
        <div class="nav-item">
          <div class="dropdown-btn">关于我们</div>
          <div class="dropdown-content">
            <router-link to="/">公司简介</router-link>
            <router-link to="/contact-us">联系我们</router-link>
          </div>
        </div>
      </div>
      <div class="nav-right">
        <div class="search-wrap">
          <i class="el-icon-search"></i>
          <input class="search-input" v-model.trim="keyword" type="text" placeholder="搜索商品" @keydown="search()">
        </div>
        <div class="login" v-if="userInfo.name == ''">
          <router-link to="/login">登录</router-link>
        </div>
        <div class="nav-item user-item" v-else>
          <div class="dropdown-btn user-name">{{userInfo.name}}</div>
          <div class="dropdown-content user-content">
            <router-link to="/my/zone">个人中心</router-link>
            <router-link to="/admin/goods" v-if="userInfo.role === 1">管理后台</router-link>
            <router-link to="/login">退出登录</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="about-goods" v-show="showGoods" @mouseover="showGoods=true" @mouseout="showGoods=false">
      <div class="nav-goods">
        <el-row :gutter="10">
          <el-col :span="6" :offset="0">
            <el-image class="nav-goods-img" :src="require('@/assets/images/nav/a.png')" fit="fill" @click="goto('/products/1')"></el-image>
            <div class="goods-serial-name" @click="goto('/products/1')">HYDRA BLUE® 臻蓝水漾系列</div>
          </el-col>
          <el-col :span="6" :offset="0">
            <el-image class="nav-goods-img" :src="require('@/assets/images/nav/b.png')" fit="fill" @click="goto('/products/2')"></el-image>
            <div class="goods-serial-name" @click="goto('/products/2')">HYDRA 4®舒缓焕活系列</div>
          </el-col>
          <el-col :span="6" :offset="0">
            <el-image class="nav-goods-img" :src="require('@/assets/images/nav/c.png')" fit="fill" @click="goto('/products/3')"></el-image>
            <div class="goods-serial-name" @click="goto('/products/3')">HYDRA MEDIC®净透控油系列</div>
          </el-col>
          <el-col :span="6" :offset="0">
            <el-image class="nav-goods-img" :src="require('@/assets/images/nav/d.png')" fit="fill" @click="goto('/products/4')"></el-image>
            <div class="goods-serial-name" @click="goto('/products/4')">HYDRA DEW PURE™赋活修复系列</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      keyword: '',
      showGoods: false,
      user: {
        role: 0
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user
    }
  },
  methods: {
    search () {
      if (this.keyword !== '') {
        const keyword = this.keyword
        this.$router.push({ path: `/products_search/${keyword}` })
      }
    },
    goto (url) {
      this.showGoods = false
      this.$router.push(url)
    },
    getStaffInfo () {
      const user = sessionStorage.getItem('user')
      if (user !== null) {
        this.user = JSON.parse(user)
        this.$store.commit('updateUserInfo', { user: this.user })
      }
    }
  },
  mounted () {
    this.getStaffInfo()
  }
}
</script>

<style scoped>
a{
  text-decoration: none;
  color: #25282a;
  display: block;
}
.page-container{
  width: 100%;
}
.nav-wrap{
  min-width: 1400px;
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.nav-item-list{
  height: 100%;
  flex: 1;
  max-width: 1200px;
  text-align: center;
}
.nav-item{
  height: 65px;
  line-height: 65px;
  font-size: 16px;
  margin: 0 1.5vw;
  box-sizing: border-box;
  font-weight: 300;
  font-style: normal;
  text-transform: none;
  color: #25282a;
  border-bottom: 1px solid #fff;
  position: relative;
  display: inline-block;
}
.nav-item:hover{
  border-bottom: 1px solid #000;
}
.nav-item:hover .dropdown-content {
  display: block;
}
.nav-item:hover .user-content {
  right: 0;
}
.user-item{
  margin: 0 10px;
}
.logo-wrap{
  padding: 10px 55px;
}
.logo{
  height: 45px;
}
.dropdown-content {
  box-sizing: border-box;
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 200px;
  line-height: 50px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
}
.dropdown-content a {
  padding: 0 15px;
}
.dropdown-content a:hover {
  background-color: #f1f1f1
}
.about-goods{
  width: 100%;
  background-color: white;
  padding: 50px;
  box-sizing: border-box;
  text-align: center;
  position: absolute;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
}
.nav-goods{
  max-width: 1200px;
  margin: 0 auto;
}
.goods-serial-name{
  font-size: 14px;
  color: #25282a;
  padding-top: 10px;
  cursor: pointer;
}
.nav-goods-img{
  width: 50%;
  cursor: pointer;
}
.nav-goods-img:hover{
  filter:brightness(95%);
}
.goods-serial-name:hover{
  font-weight: bold;
}
.nav-right{
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  font-size: 15px;
}
.search-wrap{
  border: 1px solid #DCDFE6;
  padding: 2px 1px 2px 5px;
  border-radius: 3px;
}
.search-input{
  padding: 5px 1px 5px 5px;
  border: none;
  outline: none;
  font-size: 12px;
}
.login{
  cursor: pointer;
}
.user-name{
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
